import gql from "graphql-tag";

const PUBLISH_POST_MUTATION = gql` 
mutation PublishPost($postData: PostEditInput!) {
    editPost(postData:$postData){
    id
    slug
    title
    content
    categories { 
        id
        name
    }
    authors {
      id
      firstName
      lastName
    }
    createdAt
    updatedAt
    published
    }
  }
`;
export default PUBLISH_POST_MUTATION;